import {
  ICreateManualSuscriptionRequest,
  ICreateManualSuscriptionResponse,
  IManualSuscriptionAmountMinInversionResponse,
  IManualSuscriptionContractRiskProfileResponse,
  IManualSuscriptionFundsResponse,
  IManualSuscriptionViaListResponse,
  IValidateManualSuscriptionIdentityRequest,
  IValidateManualSuscriptionIdentityResponse,
} from '../common/interfaces'
import { apiUrl } from '../config/api'

export const ManualSuscriptionService = () => {
  const validateIdentity = (req: IValidateManualSuscriptionIdentityRequest) =>
    apiUrl
      .post('suscription/manual/validate-identity', req)
      .then((res) => res.data as IValidateManualSuscriptionIdentityResponse)

  const getContractRiskProfile = (customer_id: string, cod_participe: string) =>
    apiUrl
      .get(`suscription/manual/contract-risk-profile/${customer_id}`, {
        params: { cod_participe },
      })
      .then((res) => res.data as IManualSuscriptionContractRiskProfileResponse)

  const listFunds = (customer_id: string, risk_profile_id?: number) =>
    apiUrl
      .get(`suscription/manual/funds/${customer_id}`, {
        params: risk_profile_id ? { risk_profile_id } : undefined,
      })
      .then((res) => res.data as IManualSuscriptionFundsResponse)

  const getAmountMinInversion = (customer_id: string) =>
    apiUrl
      .get(`suscription/manual/amount-min-inversion/${customer_id}`)
      .then((res) => res.data as IManualSuscriptionAmountMinInversionResponse)

  const listVias = () =>
    apiUrl.get('suscription/via/list').then((res) => res.data as IManualSuscriptionViaListResponse)

  const createManual = (req: ICreateManualSuscriptionRequest) =>
    apiUrl
      .post('suscription/create-manual', req)
      .then((res) => res.data as ICreateManualSuscriptionResponse)

  return {
    validateIdentity,
    getContractRiskProfile,
    listFunds,
    getAmountMinInversion,
    listVias,
    createManual,
  }
}
